export default __webpack_public_path__ + "static/media/bluepink.eab1a91b.jpg";